import {
  Button,
  Checkbox,
  Grid,
  MenuItem,
  Select,
  Switch,
  TextField,
  Tooltip,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import useStyles from "./VendorDetail.css";
import translation from "../../../i18n/i18.json";
import { CommunicationMethod } from "../../../models/CommunicationMethod";
import { VendorDetailState } from "../../../reducers/vendor/VendorDetailReducer";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import ContactDetailMobileDialog from "./ContactDetailMobileDialog";
import { VendorDetailService } from "../../../services/VendorDetailService";
import { VendorDetailContactMeta } from "../../../models/VendorDetail/VendorDetailContactMeta";
import ContactDetailEmailDialog from "./ContactDetailEmailDialog";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { Country } from "../../../models/Country";
import { RegionCode } from "../../../models/RegionCode";
import clsx from "clsx";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useDispatch } from "react-redux";
import AllActions from "../../../actions";
import { FieldsLengthConstants } from "../../../constants/AppConstants";

export default function ContactDetail(props: any) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    getErrorState,
    handleChange,
    isEditableMode,
    handleOnBlur,
    comunctionmethods,
    countries,
    regioncodes,
    getCompareField,
    isRegionRequired
  } = props;

  const [openMobileNumberDialog, setOpenMobileNumberDialog] = useState(false);
  const [openEmailNoteDialog, setOpenEmailNoteDialog] = useState(false);

  const vendorDetail: VendorDetailState = useSelector<
    RootState,
    VendorDetailState
  >((state) => state.vendorDetails);

  const handleMobileNumberAddPress = (e: any) => {
    setOpenMobileNumberDialog(true);
  };

  const handleEmailNoteAddPress = (e: any) => {
    setOpenEmailNoteDialog(true);
  };

  const handleChangeAutoCompete = (e: any, input: string, newValue: any) => {
    if (input === "AddressCoutry") {
      if (newValue) {
        handleChange("AddressCoutry")(e, newValue.code);
        updateCountryData(newValue.code);
      } else {
        //handleChange("AddressCoutry")(e);
        updateCountryData("");
      }
    }
  };

  const updateCountryData = (newValue: string) => {
    dispatch(AllActions.vendorDetailActions.updateDataField("AddressCoutry", newValue));
    dispatch(AllActions.vendorDetailActions.updateDataField("RegionCode", ""));
    dispatch(AllActions.vendorDetailActions.updateDataField("PrefPayMethod", []));
  };

  return (
    <div>
      <Grid
        container
        spacing={2}
        item
        xs={12}
        sm={12}
        md={11}
        lg={12}
        className={classes.formOneWrapper}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
          className={!isEditableMode ? classes.compDisableCls : ""}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_contactdetails_addnum_lbl}
              <label hidden={getCompareField("AddressStreet")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <Tooltip title={translation.vendor_form_special_character_tooltip} placement="bottom-start">
              <TextField
                variant="outlined"
                value={vendorDetail.AddressNumberStreet || ""}
                onChange={handleChange("AddressNumberStreet")}
                error={getErrorState("AddressNumberStreet")}
                inputProps={{
                  maxLength: FieldsLengthConstants.AddressNumberStreet,
                }}
              />
            </Tooltip>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
          className={!isEditableMode ? classes.compDisableCls : ""}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_contactdetails_poscode_lbl}
              <label hidden={getCompareField("AddressPostalCode")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              value={vendorDetail.AddressPostalCode || ""}
              onChange={handleChange("AddressPostalCode")}
              error={getErrorState("AddressPostalCode")}
              inputProps={{
                maxLength: FieldsLengthConstants.AddressPostalCode,
              }}
              onBlur={handleOnBlur("AddressPostalCode")}
            />
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
          className={!isEditableMode ? classes.compDisableCls : ""}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_contactdetails_city_lbl}
              <label hidden={getCompareField("AddressCity")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              value={vendorDetail.AddressCity || ""}
              onChange={handleChange("AddressCity")}
              error={getErrorState("AddressCity")}
              inputProps={{ maxLength: FieldsLengthConstants.AddressCity }}
            />
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
          className={!isEditableMode ? classes.compDisableCls : ""}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_contactdetails_country_lbl}
              <label hidden={getCompareField("AddressCountry")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <Autocomplete
              options={countries.map((obj: Country, index: number) => obj)}
              getOptionLabel={(option) => option.name}
              disabled
              onChange={(e, newValue) => {
                e.preventDefault();
                handleChangeAutoCompete(e, "AddressCoutry", newValue);
              }}
              value={
                countries.find(
                  (element: Country) =>
                    element.code === vendorDetail.AddressCoutry
                ) || null
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="outlined"
                  error={getErrorState("AddressCoutry")}
                  inputProps={{
                    ...params.inputProps,
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
          className={!isEditableMode ? classes.compDisableCls : ""}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_contactdetails_regncd_lbl}
              <label hidden={getCompareField("AddressRegionCode")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={isRegionRequired() ? classes.inputWrapper_Req : classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <Select
              variant="outlined"
              value={vendorDetail.RegionCode || ""}
              onChange={handleChange("RegionCode")}
              error={getErrorState("RegionCode")}
            >
              <MenuItem value="">
                <em>{translation.dropdown_empty_text}</em>
              </MenuItem>
              {regioncodes.map((obj: RegionCode, index: number) => (
                <MenuItem key={obj.code} value={obj.code}>
                  {obj.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
          className={!isEditableMode ? classes.compDisableCls : ""}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_contactdetails_contctforpay_lbl}
              <label hidden={getCompareField("PaymentContactPersonName")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              value={vendorDetail.PaymentContactPersonName || ""}
              onChange={handleChange("PaymentContactPersonName")}
              error={getErrorState("PaymentContactPersonName")}
              inputProps={{ maxLength: FieldsLengthConstants.PaymentContactName }}
            />
          </Grid>
        </Grid>
        {/* <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
          className={!isEditableMode ? classes.compDisableCls : ""}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_contactdetails_contctforpay_2_lbl}
              <label hidden={getCompareField("PaymentContactPersonName2")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              value={vendorDetail.PaymentContactPersonName2 || ""}
              onChange={handleChange("PaymentContactPersonName2")}
              error={getErrorState("PaymentContactPersonName2")}
              inputProps={{ maxLength: FieldsLengthConstants.PaymentContactName }}
            />
          </Grid>
        </Grid> */}
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
          className={!isEditableMode ? classes.compDisableCls : ""}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_contactdetails_contctperdes_lbl}
              <label hidden={getCompareField("ContactPersonDesignation")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              value={vendorDetail.PaymentContactPersonDesig || ""}
              onChange={handleChange("PaymentContactPersonDesig")}
              error={getErrorState("PaymentContactPersonDesig")}
            />
          </Grid>
        </Grid>
        <Grid item container xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_contactdetails_tel_lbl}
              <label hidden={getCompareField("VendorContactDetails")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} >
            <TextField
                variant="outlined"
                value={vendorDetail.MobileNumberText || ""}
                onChange={handleChange("MobileNumberText")}
                error={getErrorState("MobileNumberText")}
              />
            {/* <div className={classes.addBtnWrapper}>
              {isEditableMode ? (
                <Button onClick={handleMobileNumberAddPress}>
                  <AddCircleIcon></AddCircleIcon>
                  {translation.vendor_detail_contactdetails_add_lbl}
                </Button>
              ) : (
                <Button onClick={handleMobileNumberAddPress}>
                  {translation.vendor_detail_contactdetails_view_lbl}
                </Button>
              )}
            </div> */}
          </Grid>
        </Grid>
        <Grid item container xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_contactdetails_email_lbl}
              <label hidden={getCompareField("VendorEmails")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <div className={classes.addBtnWrapper}>
              {isEditableMode ? (
                <Button onClick={handleEmailNoteAddPress}>
                  <AddCircleIcon></AddCircleIcon>
                  {translation.vendor_detail_contactdetails_add_lbl}
                </Button>
              ) : (
                <Button onClick={handleEmailNoteAddPress}>
                  {translation.vendor_detail_contactdetails_view_lbl}
                </Button>
              )}
            </div>
          </Grid>
        </Grid>
        {/* <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
          className={!isEditableMode ? classes.compDisableCls : ""}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_contactdetails_website_lbl}
              <label hidden={getCompareField("VendorCompanyWebAddress")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              value={vendorDetail.CompanyWebSite || ""}
              onChange={handleChange("CompanyWebSite")}
              error={getErrorState("CompanyWebSite")}
              inputProps={{ maxLength: FieldsLengthConstants.CompanyWebSite }}
            />
          </Grid>
        </Grid> */}
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
          className={!isEditableMode ? classes.compDisableCls : ""}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_contactdetails_commetod_lbl}
              <label hidden={getCompareField("PreferedCommMethodId")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <Select
              variant="outlined"
              value={vendorDetail.PrefCommunMethod || ""}
              onChange={handleChange("PrefCommunMethod")}
              error={getErrorState("PrefCommunMethod")}
            >
              {comunctionmethods.map(
                (obj: CommunicationMethod, index: number) => (
                  <MenuItem key={obj.code} value={obj.code}>
                    {obj.name}
                  </MenuItem>
                )
              )}
            </Select>
          </Grid>
        </Grid>
      </Grid>
      {/* <ContactDetailMobileDialog
        open={openMobileNumberDialog}
        setOpen={setOpenMobileNumberDialog}
        isEditmode={isEditableMode}
      ></ContactDetailMobileDialog> */}      
      <ContactDetailEmailDialog
        open={openEmailNoteDialog}
        setOpen={setOpenEmailNoteDialog}
        isEditmode={isEditableMode}
      ></ContactDetailEmailDialog>
    </div>
  );
}
